import { _user, _Config } from "@discovery/common-dplus/lib/state";
import { useGlobalState } from "@discovery/common-dplus/lib/hooks";
import * as M from "@discovery/prelude/lib/data/maybe";
export const useAds = () => {
    const [userM] = useGlobalState(_user);
    const [configM] = useGlobalState(_Config);
    /** check to decide whether to show/hide ads based on the user package */
    const adsM = M.chain((x) => x.ads, configM);
    const excludePackagesM = M.chain((x) => x.excludePackages, adsM);
    const excludePackages = M.fromMaybe(excludePackagesM, []);
    const premiumPackagesM = M.chain((x) => x.premiumPackages, configM);
    const premiumPackages = M.fromMaybe(premiumPackagesM, []);
    const userPackagesM = M.chain((user) => user.attributes.packages, userM);
    const userPackages = M.fromMaybe(userPackagesM, []);
    const intersection = userPackages.filter((x) => excludePackages.includes(x));
    const adsHasValidPackage = JSON.stringify(intersection) === JSON.stringify(premiumPackages);
    /** A boolean that represents ads is enabled or not */
    const featureTogglesM = M.chain((x) => x.featureToggles, configM);
    const enableAdsM = M.chain((x) => x.enableAds, featureTogglesM);
    const enableAds = M.fromMaybe(enableAdsM, false);
    return { adsHasValidPackage, adsM, enableAds };
};

